import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton } from '@mui/material';

interface CustomDialogTitleProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const CustomDialogTitle = ({ children, onClose }: CustomDialogTitleProps) => (
  <DialogTitle sx={{ m: 0, py: 2, pl: 3, pr: 8 }}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: '8px',
          top: '8px',
          color: 'grey[500]',
        }}
        onClick={onClose}
        size="large"
      >
        <Close />
      </IconButton>
    ) : null}
  </DialogTitle>
);

export default CustomDialogTitle;
